import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ClientLoaderService } from './client-loader.service';
import { getI18nBasePath } from './client-path.util';

export class CustomClientTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private clientService: ClientLoaderService
  ) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    return from(this.clientService.getClientName()).pipe(
      switchMap(clientName => {
        const clientPath = `${getI18nBasePath()}/${clientName}/${lang}.json`;
        const defaultPath = `${getI18nBasePath()}/default/${lang}.json`;
        return forkJoin({
          defaults: this.http.get<Record<string, unknown>>(defaultPath).pipe(
            catchError(() => of({}))
          ),
          client: this.http.get<Record<string, unknown>>(clientPath).pipe(
            catchError(() => of({}))
          ),
        }).pipe(
          map(({ defaults, client }) =>
            this.overlayClientTexts(this.deepMerge(defaults, client))
          )
        );
      })
    );
  }

  private deepMerge(
    base: Record<string, unknown>,
    overlay: Record<string, unknown>
  ): Record<string, unknown> {
    const result = { ...base };
    for (const key of Object.keys(overlay)) {
      const baseValue = result[key];
      const overlayValue = overlay[key];
      if (
        baseValue &&
        overlayValue &&
        typeof baseValue === 'object' &&
        typeof overlayValue === 'object' &&
        !Array.isArray(baseValue) &&
        !Array.isArray(overlayValue)
      ) {
        result[key] = this.deepMerge(
          baseValue as Record<string, unknown>,
          overlayValue as Record<string, unknown>
        );
      } else {
        result[key] = overlayValue;
      }
    }
    return result;
  }

  /** Sobrescribe textos de registro desde /api/cliente o theme JSON */
  private overlayClientTexts(translations: Record<string, unknown>): Record<string, unknown> {
    const result = { ...translations };
    const app = { ...(result['APP'] as Record<string, string> || {}) };
    const titleRegister = this.clientService.getConfigSync('TITLE_REGISTER');
    const textRegister = this.clientService.getConfigSync('TEXT_REGISTER');
    if (titleRegister) {
      app['TITLE_REGISTER'] = titleRegister;
    }
    if (textRegister) {
      app['TEXT_REGISTER'] = textRegister;
    }
    if (Object.keys(app).length) {
      result['APP'] = app;
    }
    return result;
  }
}
